/* ============================================================
   the othr — Search (othr-search.liquid)
   Client-side instant search over an index inlined by Liquid
   (products + field notes + pages, with metafield-driven kickers).
   Ported from search-prototype/. Scoped to the .os section root so
   it is safe regardless of where the section is mounted.

   The form is a real GET to routes.search_url, so submitting reloads
   /search?q=… ; this script reads ?q= on boot and runs the same
   client-side search, and Shopify's server-rendered <noscript> block
   covers the no-JS case.
   ============================================================ */
(function () {
  "use strict";

  function boot(root) {
    if (!root || root.dataset.osReady === "1") return;
    root.dataset.osReady = "1";

    var $  = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---- config + index (inlined by Liquid) ---- */
    var DATA = { index: [], popular: [], needs: [] };
    try {
      var raw = $("[data-search-index]");
      if (raw) DATA = JSON.parse(raw.textContent);
    } catch (e) { /* leave defaults */ }
    var INDEX   = DATA.index   || [];
    var POPULAR = DATA.popular || [];
    var NEEDS   = DATA.needs   || [];

    var ICONS = {
      flag:'<path d="M5 21V4M5 4h11l-1.5 3L16 10H5"/>',
      factory:'<path d="M3 21h18M5 21V9l5 3V9l5 3V6l4 2v13"/>',
      bag:'<path d="M6 7h12l-1 14H7L6 7Zm3 0a3 3 0 0 1 6 0"/>',
      book:'<path d="M4 5a2 2 0 0 1 2-2h12v16H6a2 2 0 0 0-2 2V5Z"/>',
      mail:'<path d="M3 6h18v12H3zM3 7l9 6 9-6"/>',
      truck:'<path d="M2 6h11v9H2zM13 9h4l4 3v3h-8M6 18a2 2 0 1 0 0-.01M18 18a2 2 0 1 0 0-.01"/>',
      undo:'<path d="M3 9h11a5 5 0 0 1 0 10H8M3 9l4-4M3 9l4 4"/>'
    };
    var TYPE_LABEL = { product: "Products", article: "Blogs", page: "Pages" };
    var TYPE_ORDER = ["product", "article", "page"];

    /* normalise tags once: build a lowercase keyword token list per item */
    INDEX.forEach(function (it) {
      var kw = (it.keywords || "") + " " + (it.title || "");
      it._tags = norm(kw).split(/[^a-z0-9]+/).filter(Boolean);
    });

    /* ---- scoring engine ---- */
    /* Brand vocabulary → catalogue terms. The store's products carry no tags,
       so kickers/keywords come from the format + category metaobjects; this
       map lets shoppers' words ("caffeine", "recovery") reach the right gear. */
    var SYN = {
      caffeine: ["coffee"], espresso: ["coffee"], mocha: ["coffee"], brew: ["coffee"],
      berry: ["berries"], fruit: ["berries"], red: ["berries"],
      nut: ["nuts"], peanut: ["nuts"], almond: ["nuts"], seed: ["nuts"],
      recovery: ["calm", "unwind"], relax: ["calm", "unwind"], rest: ["calm"], wind: ["unwind"], "down": ["unwind"],
      bar: ["bars"], snack: ["bars"], cookie: ["cookies"], cake: ["cakes"],
      protein: ["protein", "nuts"], fuel: ["energy"], deep: ["focus"], work: ["focus"]
    };
    function expand(t) { return SYN[t] ? [t].concat(SYN[t]) : [t]; }

    function norm(s) { return String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }
    function tokenize(s) { return norm(s).split(/[^a-z0-9]+/).filter(Boolean); }

    function termScore(item, t) {
      var title = norm(item.title);
      var body  = norm(item.body || "");
      var tags  = item._tags || [];
      var best = 0;
      if (title === t) best = Math.max(best, 120);
      if (title.indexOf(t) === 0) best = Math.max(best, 80);
      if (title.indexOf(t) !== -1) best = Math.max(best, 55);
      if (tags.indexOf(t) !== -1) best = Math.max(best, 60);
      if (tags.some(function (x) { return x.indexOf(t) === 0; })) best = Math.max(best, 35);
      if (body.indexOf(t) !== -1) best = Math.max(best, 18);
      if (best && best <= 18 && new RegExp("\\b" + t).test(body)) best += 6;
      return best;
    }
    function scoreItem(item, terms) {
      var total = 0;
      for (var i = 0; i < terms.length; i++) {
        var variants = expand(terms[i]);
        var best = 0;
        for (var v = 0; v < variants.length; v++) best = Math.max(best, termScore(item, variants[v]));
        if (best === 0) return 0;             // AND: every query term (or a synonym) must hit
        total += best;
      }
      if (item.type === "product") total += 4;
      return total;
    }
    function search(query) {
      var terms = tokenize(query);
      if (!terms.length) return [];
      return INDEX
        .map(function (item) { return { item: item, score: scoreItem(item, terms) }; })
        .filter(function (r) { return r.score > 0; })
        .sort(function (a, b) { return b.score - a.score; })
        .map(function (r) { return r.item; });
    }

    function escapeHTML(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;" })[c]; }); }
    function highlight(text, terms) {
      var out = escapeHTML(text);
      var uniq = terms.filter(function (v, i) { return terms.indexOf(v) === i && v; })
                      .sort(function (a, b) { return b.length - a.length; });
      uniq.forEach(function (t) {
        var re = new RegExp("(" + t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
        out = out.replace(re, "<mark>$1</mark>");
      });
      return out;
    }

    /* ---- DOM refs ---- */
    var form     = $("[data-search-form]");
    var input    = $("[data-search-input]");
    var clearBtn = $("[data-search-clear]");
    var slashHint= $("[data-search-kbd]");
    var scopesEl = $("[data-search-scopes]");
    var metaEl   = $("[data-search-meta]");
    var emptyEl  = $("[data-search-empty]");
    var resultsEl= $("[data-search-results]");
    var noResEl  = $("[data-search-noresults]");
    var popularUl= $("[data-search-popular]");
    var recentUl = $("[data-search-recent]");
    var recentLbl= $("[data-search-recent-label]");
    var needTiles= $("[data-search-needs]");

    if (!input || !resultsEl) return;

    var scope = "all";
    var lastHits = [];
    var cursor = -1;

    var RECENT_KEY = "othr.search.recent";
    function loadRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
    function saveRecent(arr) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 6))); } catch (e) {} }

    /* ---- renderers ---- */
    function hitMedia(item) {
      if (item.img) return '<span class="os-hit__media"><img src="' + escapeHTML(item.img) + '" alt="" loading="lazy"></span>';
      var icon = ICONS[item.icon] || ICONS.book;
      return '<span class="os-hit__media os-hit__media--icon"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5">' + icon + '</svg></span>';
    }
    function hitAside(item) {
      if (item.type === "product") {
        return '<span class="os-hit__aside"><span class="os-hit__price">' + escapeHTML(item.price || "") + '</span><span class="os-hit__stat">' + escapeHTML(item.stat || "") + '</span><span class="os-hit__go" aria-hidden="true">→</span></span>';
      }
      var meta = item.date || "";
      return '<span class="os-hit__aside">' + (meta ? '<span class="os-hit__stat">' + escapeHTML(meta) + '</span>' : "") + '<span class="os-hit__go" aria-hidden="true">→</span></span>';
    }
    function hitHTML(item, terms) {
      var sub = item.type === "product" ? "" : '<p class="os-hit__sub">' + highlight(item.body || "", terms) + '</p>';
      return '<li><a class="os-hit" href="' + escapeHTML(item.url) + '" data-title="' + escapeHTML(item.title) + '">' +
        hitMedia(item) +
        '<span class="os-hit__body">' +
          '<span class="os-hit__kicker">' + escapeHTML(item.kicker || TYPE_LABEL[item.type]) + '</span>' +
          '<span class="os-hit__title">' + highlight(item.title, terms) + '</span>' + sub +
        '</span>' + hitAside(item) +
      '</a></li>';
    }
    function renderResults(hits, terms) {
      var visible = scope === "all" ? hits : hits.filter(function (h) { return h.type === scope; });
      lastHits = visible; cursor = -1;
      if (!visible.length) { resultsEl.hidden = true; resultsEl.innerHTML = ""; return; }
      var html = "";
      TYPE_ORDER.forEach(function (t) {
        var group = visible.filter(function (h) { return h.type === t; });
        if (!group.length) return;
        html += '<div class="os-results__group">' +
          '<div class="os-eyebrow os-results__grouphd"><span class="os-rule"></span> ' + TYPE_LABEL[t] + ' <span class="os-scope__n">' + group.length + '</span></div>' +
          '<ul class="os-results__list">' + group.map(function (it) { return hitHTML(it, terms); }).join("") + '</ul>' +
        '</div>';
      });
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
    }
    function setCounts(hits) {
      var counts = { all: hits.length, product: 0, article: 0, page: 0 };
      hits.forEach(function (h) { counts[h.type]++; });
      $$("[data-count-for]", scopesEl).forEach(function (el) { el.textContent = counts[el.getAttribute("data-count-for")]; });
      $$(".os-scope", scopesEl).forEach(function (btn) {
        var k = btn.getAttribute("data-scope");
        btn.disabled = k !== "all" && counts[k] === 0;
      });
    }

    /* ---- the query cycle ---- */
    function run(query, opts) {
      opts = opts || {};
      var q = (query || "").trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (slashHint) slashHint.hidden = q.length > 0 || document.activeElement === input;
      input.setAttribute("aria-expanded", String(q.length > 0));

      if (opts.pushUrl !== false) {
        try {
          var url = new URL(location.href);
          if (q) url.searchParams.set("q", q); else url.searchParams.delete("q");
          history.replaceState(null, "", url);
        } catch (e) {}
      }

      if (!q) {
        renderEmptyState();
        if (emptyEl) emptyEl.hidden = false;
        resultsEl.hidden = true; resultsEl.innerHTML = "";
        if (noResEl) noResEl.hidden = true;
        if (metaEl) metaEl.innerHTML = "";
        lastHits = []; cursor = -1;
        $$("[data-count-for]").forEach(function (el) { el.textContent = "—"; });
        $$(".os-scope").forEach(function (b) { b.disabled = false; });
        return;
      }

      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      var hits = search(q);
      var ms = Math.max(1, Math.round(((window.performance && performance.now) ? performance.now() : Date.now()) - t0));
      var terms = tokenize(q);

      if (emptyEl) emptyEl.hidden = true;
      setCounts(hits);

      if (!hits.length) {
        resultsEl.hidden = true; resultsEl.innerHTML = "";
        if (noResEl) noResEl.hidden = false;
        var termEl = $("[data-search-noresults-term]");
        if (termEl) termEl.textContent = "“" + q + "”";
        if (metaEl) metaEl.innerHTML = "<b>0</b> results for “" + escapeHTML(q) + "”";
        return;
      }

      if (noResEl) noResEl.hidden = true;
      renderResults(hits, terms);
      var shown = lastHits.length;
      var scopeWord = scope === "all" ? "" : (" in " + TYPE_LABEL[scope]);
      if (metaEl) metaEl.innerHTML = "<b>" + shown + "</b> result" + (shown === 1 ? "" : "s") + scopeWord + " for “" + escapeHTML(q) + "” · " + ms + "ms";
    }

    var debTimer;
    function onInput() {
      clearTimeout(debTimer);
      debTimer = setTimeout(function () { run(input.value); }, 90);
      if (clearBtn) clearBtn.hidden = input.value.length === 0;
    }
    function commitRecent(term) {
      term = (term || "").trim();
      if (!term) return;
      var arr = loadRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
      arr.unshift(term);
      saveRecent(arr);
    }

    /* ---- empty-state chips / tiles ---- */
    function chip(label, cls) {
      return '<li><button type="button" class="os-chip ' + (cls || "") + '" data-q="' + escapeHTML(label) + '"><span class="os-chip__icon" aria-hidden="true">↗</span>' + escapeHTML(label) + '</button></li>';
    }
    function renderEmptyState() {
      if (popularUl) popularUl.innerHTML = POPULAR.map(function (p) { return chip(p); }).join("");
      var recent = loadRecent();
      if (recentLbl) recentLbl.hidden = recent.length === 0;
      if (recentUl) recentUl.innerHTML = recent.map(function (r) { return chip(r, "os-chip--recent"); }).join("");
      if (needTiles) needTiles.innerHTML = NEEDS.map(function (n) {
        return '<button type="button" class="os-tile" data-q="' + escapeHTML(n.q) + '">' +
          '<span class="os-eyebrow" style="opacity:.5">Need</span>' +
          '<span class="os-tile__name">' + escapeHTML(n.name) + '</span>' +
          '<span class="os-tile__desc">' + escapeHTML(n.desc) + '</span>' +
          '<span class="os-tile__ghost" aria-hidden="true">' + escapeHTML(n.ghost || "") + '</span>' +
        '</button>';
      }).join("");
    }
    function renderNoResultsChips() {
      var el = $("[data-search-noresults-chips]");
      if (el) el.innerHTML = POPULAR.slice(0, 4).map(function (p) { return chip(p); }).join("");
    }

    /* clicks: chips/tiles seed; hits commit recent */
    root.addEventListener("click", function (e) {
      var seed = e.target.closest("[data-q]");
      if (seed) {
        var q = seed.getAttribute("data-q");
        input.value = q; input.focus(); run(q); commitRecent(q);
        return;
      }
      var hit = e.target.closest(".os-hit");
      if (hit) commitRecent(input.value);   // let the link navigate
    });

    var clearRecent = $("[data-search-clear-recent]");
    if (clearRecent) clearRecent.addEventListener("click", function () { saveRecent([]); renderEmptyState(); });

    /* ---- scopes ---- */
    if (scopesEl) scopesEl.addEventListener("click", function (e) {
      var btn = e.target.closest(".os-scope");
      if (!btn || btn.disabled) return;
      scope = btn.getAttribute("data-scope");
      $$(".os-scope", scopesEl).forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", String(on));
      });
      if (input.value.trim()) run(input.value, { pushUrl: false });
    });

    /* ---- keyboard ---- */
    function visibleHitEls() { return $$(".os-hit", resultsEl); }
    function setCursor(next) {
      var els = visibleHitEls();
      if (!els.length) return;
      cursor = (next + els.length) % els.length;
      els.forEach(function (el, i) { el.classList.toggle("is-cursor", i === cursor); });
      els[cursor].scrollIntoView({ block: "nearest" });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "/" && document.activeElement !== input &&
          !/^(input|textarea|select)$/i.test((document.activeElement.tagName || ""))) {
        e.preventDefault(); input.focus(); input.select();
      }
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); setCursor(cursor + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setCursor(cursor - 1); }
      else if (e.key === "Enter") {
        var els = visibleHitEls();
        if (cursor >= 0 && els[cursor]) { e.preventDefault(); commitRecent(input.value); els[cursor].click(); }
        else { commitRecent(input.value); }
      } else if (e.key === "Escape") {
        if (input.value) { input.value = ""; run(""); } else input.blur();
      }
    });
    resultsEl.addEventListener("mousemove", function (e) {
      var hit = e.target.closest(".os-hit");
      if (!hit) return;
      var els = visibleHitEls(); var i = els.indexOf(hit);
      if (i !== cursor) { cursor = i; els.forEach(function (el, j) { el.classList.toggle("is-cursor", j === i); }); }
    });

    /* ---- wiring ---- */
    input.addEventListener("input", onInput);
    input.addEventListener("focus", function () { if (slashHint) slashHint.hidden = true; });
    input.addEventListener("blur",  function () { if (slashHint && !input.value) slashHint.hidden = false; });
    if (form) form.addEventListener("submit", function (e) {
      // run client-side instantly; don't full-page reload when JS is on
      e.preventDefault(); commitRecent(input.value); run(input.value); input.blur();
    });
    if (clearBtn) clearBtn.addEventListener("click", function () { input.value = ""; input.focus(); run(""); });

    /* ---- boot ---- */
    renderEmptyState();
    renderNoResultsChips();
    var initial = "";
    try { initial = new URLSearchParams(location.search).get("q") || ""; } catch (e) {}
    if (!initial && input.value) initial = input.value;   // server may pre-fill from search.terms
    if (initial) { input.value = initial; run(initial, { pushUrl: false }); }
    else if (window.matchMedia && matchMedia("(min-width: 768px)").matches) { input.focus(); }
  }

  function init() { boot(document.querySelector(".os")); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector(".os") : null;
    if (el) { el.dataset.osReady = ""; boot(el); }
  });
})();
